import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

interface IRolloGuardadoModalProps {
  showModal: boolean;
  toggleModal: () => void;
}

function RolloGuardadoModal(props: IRolloGuardadoModalProps) {
  return (
    <div>
      <Modal isOpen={props.showModal} toggle={props.toggleModal}>
        <ModalHeader toggle={props.toggleModal}>Modal title</ModalHeader>
        <ModalBody>Guardado!</ModalBody>
      </Modal>
    </div>
  );
}

export default RolloGuardadoModal;
